// Nederlands (nl-nl) landing-page messages.
export default {
  nav: {
    features: 'Functies',
    howItWorks: 'Hoe het werkt',
    pricing: 'Prijzen',
    login: 'Inloggen',
    startFree: 'Gratis starten'
  },
  hero: {
    badge: 'Monitoring',
    statusLine: 'E-mail + sms verzonden · incident gestart 14:07',
    titleTop: 'Jouw website heeft',
    titleAccent: 'een hartslag.',
    subtitle: 'Weet binnen een minuut wanneer je site uitvalt — voordat je klanten het merken. Elke minuut gecontroleerd, direct gewaarschuwd.',
    ctaPrimary: 'Subscribe →',
    ctaSecondary: 'Inloggen op dashboard',
    scroll: 'Scroll'
  },
  features: {
    kicker: 'Wat je krijgt',
    titleTop: 'Alles wat je nodig hebt.',
    titleAccent: 'Niets overbodigs.',
    subtitle: 'Eenvoudige, gerichte monitoring voor ondernemers die simpelweg willen weten dat hun site online is.',
    items: [
      { title: 'Controle elke minuut', body: 'Elke 60 seconden gepingd vanaf meerdere locaties. Downtime binnen een minuut gedetecteerd.' },
      { title: 'E-mail- & sms-meldingen', body: 'Zodra er iets misgaat krijg je een melding — geen app om in de gaten te houden, geen dashboard om te bewaken.' },
      { title: 'Maandelijkse rapporten', body: 'Elke maand een helder uptime-rapport in je inbox: uptime %, responstijden en incidenthistorie.' },
      { title: 'Subdomeinen inbegrepen', body: 'Monitor je hoofddomein plus tot 5 subdomeinen — shop, blog, api — allemaal onder één abonnement.' }
    ]
  },
  how: {
    kicker: 'Hoe het werkt',
    title: 'In drie minuten live.',
    subtitle: 'Geen installatie, geen code, geen leercurve. Voeg je URL toe en je bent gedekt.',
    steps: [
      { title: 'Voeg je website toe', body: 'Voer je domein in en eventuele subdomeinen die je wilt bewaken. Duurt 30 seconden.' },
      { title: 'Stel je meldingen in', body: 'Kies waar je gewaarschuwd wilt worden — e-mail, sms of beide. Voeg meerdere contacten toe.' },
      { title: 'Wij bewaken. Jij ontspant.', body: 'Custus controleert elke minuut. Gaat er iets mis, dan hoor je het direct.' }
    ]
  },
  pricing: {
    kicker: 'Prijzen',
    title: 'Eenvoudige abonnementen. Heldere prijzen.',
    subtitle: 'Kies het aantal sites dat je nodig hebt. Geen verborgen kosten, altijd opzegbaar.',
    note: 'Geen creditcard nodig om te starten. Wijzig je abonnement altijd vanaf je dashboard.',
    perMonth: 'per maand'
  },
  demo: {
    title: 'Vraag een demo aan',
    subtitle: 'Vertel ons over je site en we laten Custus in actie zien.',
    name: 'Je naam',
    email: 'E-mail',
    website: 'Te monitoren website',
    submit: 'Demo aanvragen',
    sending: 'Verzenden…',
    successTitle: 'Bedankt!',
    successBody: 'We nemen snel contact met je op.'
  },
  footer: {
    tagline: 'Websitemonitoring die nooit slaapt.',
    privacy: 'Privacy',
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    contact: 'Contact'
  }
}
